module.exports = __webpack_public_path__ + "img/C26.7f28d84b.png";